import * as THREE from "three";

const _box = new THREE.Box3();

export default function _setAvatarApi(avatar) {
  // Enable control related api > how about change to global api

  avatar.setFollowingCamera = camera => {
    let followingCamera = camera;
    if (!followingCamera) {
      followingCamera = this.context.createPlayCamera();
      this.setApis(followingCamera);
      this.context.updateCameraOrder();
    }
    avatar.manager.setFollowingCamera(followingCamera);
    // this.context.playCamera = followingCamera;

    this.context.createPlayControls(followingCamera);

    return followingCamera;
  };

  avatar.setDefaultController = () => {
    avatar.manager.setDefaultController();
  };

  avatar.spawn = target => {
    if (!avatar.body) return;

    let targetObject;
    if (target) {
      if (typeof target === "string") targetObject = this.context.scenePlay.getObjectByProperty("title", target);
      else targetObject = target;
    } else if (this.context.startLocation) {
      targetObject = this.context.startLocation;
    }
    if (!targetObject) return;

    _box.setFromObject(avatar);
    const offset = 1 + (_box.max.y - _box.min.y) / 2;
    _box.setFromObject(targetObject);
    avatar.body.transform();
    avatar.body.setPosition(targetObject.position.x, _box.max.y + offset, targetObject.position.z);
    avatar.body.refresh();
  };

  avatar.changePlayerSpeed = speed => {
    avatar.manager.speedFactor = speed;
  };

  avatar.changeAxisSpeed = (x, y, z) => {
    avatar.manager.deltaPosDefault.x = x;
    avatar.manager.deltaPosDefault.y = y;
    avatar.manager.deltaPosDefault.z = z;
  };

  avatar.changePlayerJumpHeight = height => {
    if (!height) return;
    avatar.manager.jumpHeight = height;
    avatar.manager.gravity = (-8 * avatar.manager.jumpHeight) / Math.pow(avatar.manager.jumpDuration, 2);
    avatar.manager.initialVelocityY = (4 * avatar.manager.jumpHeight) / avatar.manager.jumpDuration;
  };

  avatar.onTrigger = (target, callback, trigger = "start") => {
    if (!target.onCollidePlayerCallbacks) target.onCollidePlayerCallbacks = [];
    callback.trigger = trigger;
    target.onCollidePlayerCallbacks.push(callback);
    target.traverse(child => {
      if (!child.geometry) return;
      if (!child.collisionSubscribingAncestors) child.collisionSubscribingAncestors = [];
      child.collisionSubscribingAncestors.push(target);
    });
  };
}
